import { useRef, useState } from 'react';
// material
import { Box, Card, CardContent, TableCell, Typography } from '@mui/material';

import PropTypes from 'prop-types';

import MenuPopover from '../MenuPopover';
import Label from '../Label';
import { timeForm } from '../../common/utils/formatTime';

// ----------------------------------------------------------------------

DeviceMoreInfo.propTypes = {
  device: PropTypes.object,
  administrator: PropTypes.bool,
  groupId: PropTypes.number,
  positions: PropTypes.array,
  hiddenDown: PropTypes.bool
};

export default function DeviceMoreInfo({ device, administrator, groupId, positions, hiddenDown }) {
  const ref = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <TableCell component="th" scope="row" onClick={() => setIsOpen(true)} ref={ref}>
        {device.name}
      </TableCell>
      {(administrator || groupId === 0) && (
        <TableCell align="left" onClick={() => setIsOpen(true)} ref={ref}>
          {device.uniqueId}
        </TableCell>
      )}

      {!hiddenDown && <TableCell align="left">{device.phone}</TableCell>}
      {administrator && !hiddenDown && <TableCell align="left">{device.club}</TableCell>}
      <TableCell align="left" onClick={() => setIsOpen(true)} ref={ref}>
        <Label variant="ghost" color="success">
          {timeForm(
            positions
              .filter((item) => item.deviceId === device.id)
              .map((item) => item.attributes.hours)
          )}
        </Label>
      </TableCell>

      <MenuPopover
        open={isOpen}
        onClose={() => setIsOpen(false)}
        anchorEl={ref.current}
        sx={{ width: 400 }}
      >
        <Card sx={{ display: 'flex' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flex: '1 0 auto' }}>
              <Typography component="div" variant="h5">
                {device.name}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                {(administrator || groupId === 0) && device.uniqueId}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                {device.phone}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                {timeForm(
                  positions
                    .filter((item) => item.deviceId === device.id)
                    .map((item) => item.attributes.hours)
                )}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                {administrator && device.club}
              </Typography>
            </CardContent>
          </Box>
        </Card>
      </MenuPopover>
    </>
  );
}
